import {
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CREATE_USER_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  RESET_USER,
  UPDATE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  FETCH_CUSTOMER_CREDIT_CARD_REQUEST,
  FETCH_CUSTOMER_CREDIT_CARD_SUCCESS,
  FETCH_CUSTOMER_CREDIT_CARD_FAILURE,
} from './constants'

export interface CreateUserRequestAction {
  type: typeof CREATE_USER_REQUEST
  payload: {
    data: {
      email: string
      password: string
      market: string
      language: string
    }
    hostname: string
  }
}

export interface CreateUserSuccessAction {
  type: typeof CREATE_USER_SUCCESS
  payload: {
    created: true
    data: {
      email: string
      firstName: string
      userId: number
      lastName: string
      phone: string
    }
  }
}

export interface CreateUserFailureAction {
  type: typeof CREATE_USER_FAILURE
  payload: { errorCode: string }
}

export interface UpdateUserRequestAction {
  type: typeof UPDATE_USER_REQUEST
  payload: {
    hostname: string
    data: {
      firstName: string
      lastName: string
      phone: string
    }
  }
}

export interface UpdateUserSuccessAction {
  type: typeof UPDATE_USER_SUCCESS
  payload: {
    updated: true
    data: {
      firstName: string
      lastName: string
      phone: string
    }
  }
}
export interface UpdateUserFailureAction {
  type: typeof UPDATE_USER_FAILURE
  payload: { errorCode: string }
}

export interface ChangePasswordRequestAction {
  type: typeof CHANGE_PASSWORD_REQUEST
  payload: {
    hostname: string
    data: {
      currentPassword: string
      newPassword: string
    }
  }
}

export interface ChangePasswordSuccessAction {
  type: typeof CHANGE_PASSWORD_SUCCESS
  payload: {
    passwordChanged: true
  }
}

export interface ChangePasswordFailureAction {
  type: typeof CHANGE_PASSWORD_FAILURE
  payload: { errorCode: string }
}

export interface FetchCustomerCreditCardRequestAction {
  type: typeof FETCH_CUSTOMER_CREDIT_CARD_REQUEST
  payload: {
    hostname: string
    market: string
  }
}

export interface FetchCustomerCreditCardFailureAction {
  type: typeof FETCH_CUSTOMER_CREDIT_CARD_FAILURE
  payload: {
    errorCode: string
  }
}

export interface FetchCustomerCreditCardSuccessAction {
  type: typeof FETCH_CUSTOMER_CREDIT_CARD_SUCCESS
  payload: {
    creditCard: {
      brand: string
      expiryDate: string
      holder: string
      number: string
    }
  }
}

export interface ResetUserAction {
  type: typeof RESET_USER
}

export type UserActions =
  | CreateUserRequestAction
  | CreateUserSuccessAction
  | CreateUserFailureAction
  //
  | UpdateUserRequestAction
  | UpdateUserSuccessAction
  | UpdateUserFailureAction
  //
  | ChangePasswordRequestAction
  | ChangePasswordSuccessAction
  | ChangePasswordFailureAction
  //
  | FetchCustomerCreditCardRequestAction
  | FetchCustomerCreditCardSuccessAction
  | FetchCustomerCreditCardFailureAction
  //
  | ResetUserAction

export const createUserRequestAction = (payload: CreateUserRequestAction['payload']) => ({
  type: CREATE_USER_REQUEST,
  payload,
})

export const createUserSuccessAction = (payload: CreateUserSuccessAction['payload']) => ({
  type: CREATE_USER_SUCCESS,
  payload,
})

export const createUserFailureAction = (payload: CreateUserFailureAction['payload']) => ({
  type: CREATE_USER_FAILURE,
  payload,
})

export const updateUserRequestAction = (payload: UpdateUserRequestAction['payload']) => ({
  type: UPDATE_USER_REQUEST,
  payload,
})

export const updateUserSuccessAction = (payload: UpdateUserSuccessAction['payload']) => ({
  type: UPDATE_USER_SUCCESS,
  payload,
})

export const updateUserFailureAction = (payload: UpdateUserFailureAction['payload']) => ({
  type: UPDATE_USER_FAILURE,
  payload,
})

export const changePasswordRequestAction = (payload: ChangePasswordRequestAction['payload']) => ({
  type: CHANGE_PASSWORD_REQUEST,
  payload,
})

export const changePasswordSuccessAction = (payload: ChangePasswordSuccessAction['payload']) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload,
})

export const changePasswordFailureAction = (payload: ChangePasswordFailureAction['payload']) => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload,
})

export const fetchCustomerCreditCardRequestAction = (
  payload: FetchCustomerCreditCardRequestAction['payload']
) => ({
  type: FETCH_CUSTOMER_CREDIT_CARD_REQUEST,
  payload,
})

export const fetchCustomerCreditCardSuccessAction = (
  payload: FetchCustomerCreditCardSuccessAction['payload']
) => ({
  type: FETCH_CUSTOMER_CREDIT_CARD_SUCCESS,
  payload,
})

export const fetchCustomerCreditCardFailureAction = (
  payload: FetchCustomerCreditCardFailureAction['payload']
) => ({
  type: FETCH_CUSTOMER_CREDIT_CARD_FAILURE,
  payload,
})

export const resetUserAction = (): ResetUserAction => ({
  type: RESET_USER,
})
